export const userFullNameBuilder = {
  build: function (preferredFirstName, firstName, lastName) {
    return preferredFirstName || firstName || lastName ? `${preferredFirstName || firstName} ${lastName || ''}` : '--';
  },
};
